<div
  class="shade-host"
>
  <div
    #shade
    class="shade-bkgd"
  ></div>

  <div
    class="drawer-bottom"
    [class.fit-content]="fitContent"
    [ngStyle]="{
      'z-index': cssZIndex,
      'min-height': cssMinHeight,
      'margin-top': cssMarginTop
    }"
  >
    <div
      class="outer-container"
    >
      <ng-content></ng-content>
    </div>

    <motn-tile-history-viewport-buffer></motn-tile-history-viewport-buffer>
  </div>
</div>
